/**
 * Chat List Loading Skeleton
 * Shows skeleton UI for chat list page with TabBar during lazy loading
 */

import { AppShellSkeleton } from '@/components/layout/AppShellSkeleton';

export function ChatListLoadingSkeleton() {
  return <AppShellSkeleton showHeader headerTitle="Чаты" contentType="list" />;
}

export default ChatListLoadingSkeleton;
